import _get from 'lodash/get'

const getValidationErrors = (apolloError, singleError = false) => {
  const { graphQLErrors } = apolloError
  const categories = ['validation', 'custom']
  const errors = {}

  if (graphQLErrors.length > 0 && categories.includes(_get(graphQLErrors[0], 'extensions.category'))) 
  {
    // Custom error handling
    if (graphQLErrors[0].extensions.category === 'custom') {
      return graphQLErrors[0].message
    }

    // Laravel validation error handling
    if (graphQLErrors[0].extensions.category === 'validation') {
      const validationErrors = graphQLErrors[0].extensions.validation
      const errorKeys = Object.keys(validationErrors)

      errorKeys.forEach(key => {
        errors[key.replace("input.", "")] = validationErrors[key][0].replace("input.", "")
      })

      return singleError ? errors[errorKeys[0].replace("input.", "")] : errors
    }
    
    return errors
  }
}

export default getValidationErrors
